import type { useFloating, useInteractions } from '@floating-ui/react';

import { createContext, useContext } from 'react';

type Floating = ReturnType<typeof useFloating<HTMLElement>>;
type Interactions = ReturnType<typeof useInteractions>;

export type PopoverContextValue = {
  context: Floating['context'];
  floatingStyles: Floating['floatingStyles'];
  getFloatingProps: Interactions['getFloatingProps'];
  getReferenceProps: Interactions['getReferenceProps'];
  isOpen: boolean;
  setFloating: Floating['refs']['setFloating'];
  setReference: Floating['refs']['setReference'];
};

export const PopoverContext = createContext<PopoverContextValue | null>(null);

export function usePopoverContext() {
  const context = useContext(PopoverContext);
  if (context == null) {
    throw new Error(
      'PopoverTrigger and PopoverContent must be used within Popover.',
    );
  }
  return context;
}
